module.exports = __webpack_public_path__ + "static/img/17.16c41dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/17.png
// module id = 469N
// module chunks = 0